import axios from 'axios';
import {APPLE_PAY_VERSION_NUMBER} from "./PaymentConf";

const baseUrl = '';

const post = (path, data, errorMessage) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            url: baseUrl + path,
            data: data,
            headers: {'Content-Type': 'application/json'}
        })
        .then((response) => {
            if (response.status >= 200 && response.status <= 205) {
                resolve(response.data);
            } else {
                reject(new Error(errorMessage));
            }
        })
        .catch((error) => {
            reject(error);
        });
    });   
}

export const applePayValidationRequest = (url, product) => {
    const data = {
        validation_url: url,
        display_name: product.merchantName,
        version: APPLE_PAY_VERSION_NUMBER,
        origin: product.type,
        origin_id: product.token
    };
    return post('/applepay/session', data, 'Could not get session')
}

export const applePayPaymentRequest = (
    payment_data,
    quantity,
    product,
    paymentMethodId,
    category,
    billingContact,
    shippingContact) => {

    const data = {
        payment_data: payment_data,
        product: product,
        paymentMethod: paymentMethodId,
        quantity: quantity,
        category: category,
        billingContact: billingContact,
        shippingContact: shippingContact,
        session_id: window.session_id
    }
    if (product.type !== undefined) {
        data.type = product.type;
    }

    return post('/applepay/payment/' + product.token, data, 'Could not perform checkout')
        .then(response => {
            // handle response if needed
            return response;
        })
        .catch(error => {
            // handle error if needed
            throw error;
        });
}



// WEBPACK FOOTER //
// ./client/components/ApplePayRestClient.js